import { render } from "./Zabytki.vue?vue&type=template&id=f8d1e8fe"
import script from "./Zabytki.vue?vue&type=script&lang=js"
export * from "./Zabytki.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Szymon\\witryny\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__